// extracted by mini-css-extract-plugin
export default {"footer":"WQbgP","cookies":"lLBFv"};